import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';

import './ResetPassword.scss';
import styles from './ResetPassword.module.scss';

import InputText from 'components/InputText/InputText';
import { Button } from 'components/Button/Button';
import { ArrowLeft, CheckMark } from 'components/Icons/Icons';
import { AnchorText } from 'components/AnchorText/AnchorText';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';

import { useLocation } from 'react-router-dom';
import { resetPassword } from 'utils/PointsAPI';
import { routes } from '../../routing/routes';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword = () => {
  const query = useQuery();

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [passwordReset, setPasswordReset] = useState(false);
  const [buttonDisabled, setbuttonDisabled] = useState(true);

  useEffect(() => {
    setbuttonDisabled(!(password.length > 8 && passwordConfirmation === password));
  }, [setbuttonDisabled, password, passwordConfirmation]);

  return (
    <div className="reset-password-container ">
      <m.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="password-reset"
      >
        <Helmet>
          <title>Forgot Password</title>
          <meta name="description" content="Forgot password?" />
        </Helmet>

        <section>
          <div className="container pt-4">
            <div className="row mx-sm-0 mx-1 justify-content-center">
              {!passwordReset ? (
                <div className="col-xs-12 col-sm-7 pt-3">
                  <h2 className="text-center mb-2 mt-2">Set new password</h2>
                  <p className="text-center">Make sure to use a strong password.</p>

                  <HorizontalDivider />
                  <div className="mt-3">
                    <InputText
                      id="password-input"
                      label="Password"
                      value={password}
                      onChange={(event) => {
                        setPassword(event.target.value);
                      }}
                      type="password"
                      placeholder="********"
                      message="Must be at least 8 characters"
                    />
                  </div>
                  <div className="mt-3">
                    <InputText
                      id="password-input"
                      label="Password"
                      value={passwordConfirmation}
                      onChange={(event) => {
                        setPasswordConfirmation(event.target.value);
                      }}
                      type="password"
                      placeholder="********"
                    />
                  </div>
                  <div className="mt-4 mb-4">
                    <Button
                      primary
                      fullWidth
                      disabled={buttonDisabled}
                      onClick={async () => {
                        const token = query.get('token') || '';
                        const result = await resetPassword(password, token);
                        if (result) setPasswordReset(true);
                        else alert('unable to reset password');
                      }}
                    >
                      Reset password
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-xs-12 col-sm-7 pt-3">
                    <div className="col-12 check-icon">
                      <CheckMark stroke={styles.checkMarkColor} />
                    </div>

                    <h2 className="text-center mb-2 mt-2">Password reset successful</h2>
                    <p className="text-center">Your password has been sucessfully reset.</p>

                    <hr className="separator" />
                  </div>

                  <div className="text-center mb-4">
                    <AnchorText href={routes.login()}>
                      <ArrowLeft stroke={styles.leftArrowColor} />
                      Back to Login
                    </AnchorText>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </m.main>
    </div>
  );
};

export default ResetPassword;
